// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DONE = "Hotovo";
export const WIKI_ARTICLE_AMBASSADOR_BRAND_CLEAR_CONFIRM = "Si si ist\u00e1, \u017ee chce\u0161 od \u010dl\u00e1nku odpoji\u0165 tvoju ambas\u00e1dorsk\u00fa zna\u010dku?";
export const WIKI_ARTICLE_AMBASSADOR_BRAND_SET_CONFIRM = "Si si ist\u00e1, \u017ee chce\u0161 k \u010dl\u00e1nku pripoji\u0165 tvoju ambas\u00e1dorsk\u00fa zna\u010dku?";
